import { Button, DataTable, FormGroup, Label, Select } from '@/components'
import { useAxios } from '@/context/axiosContext'
import { useDialog } from '@/context/dialogContext'
import { tableStyles } from '@/styles/dataTable/style'
import commonUtils from '@/utils/commonUtils'
import React, { useEffect, useState } from 'react'
import { TableColumn } from 'react-data-table-component'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { useRedis } from '@/hooks/useRedis'
import { FlexWrapper } from '@/components/layout/flex/flexWrapper'

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
`

const Header = styled.header`
  padding: 20px;
  font-size: 20px;
  // font-weight: bold;
  display: flex;
`

const Content = styled.div`
  display: flex;
  flex: 1;
`

const TableContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 700px;
`

const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
  padding-right: 80px;
`

const StatusLabel = styled.span`
  font-size: 14px;
`

const StatusLight = styled.div<{ active: boolean; color: string }>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${(props) => (props.active ? props.color : '#ccc')};
  border: 2px solid black;
  margin: 0 auto;
`

interface BatchData {
  seq: number
  batchNm: string
  batchSeq: number
  startDate: string
  endDate: string
  status: string
  totalCnt: number
  successCnt: number
  failCnt: number
}

interface BatchInfo {
  batchNm: string
  batchStatusApi: string
  batchStartApi: string
}

const BatchExecPage: React.FC = () => {
  const axios = useAxios()
  const { getComCodeValue } = useRedis()
  const navigate = useNavigate()
  const [status, setStatus] = useState('ready') // ready, running, warning
  const [batchData, setBatchData] = useState<BatchData[]>([])
  const { showAlert } = useDialog()

  const [selectBacthIndex, setSelectBacthIndex] = useState(0);

  // const limjhTest = async () => {
  //   const response = await axios.post('/scrp/insertEmptyPriceHistory', {})
  // }

  const batchList: BatchInfo[] = [
    {
      batchNm: 'GolfDataCollector',
      batchStartApi: '/golf/start',
      batchStatusApi: '/golf/status',
    },
    {
      batchNm: 'BizDataCollector(그린피)',
      batchStartApi: '/scrp/testScraping?categoryCode=00&bizCd=',
      batchStatusApi: '/scrp/status',
    },
    {
      batchNm: 'EmptyPrceHistCollector',
      batchStartApi: '/scrp/insertTheDayEmptyPriceHistory',
      batchStatusApi: '/scrp/emptyPriceHistStatus',
    }
  ]

  const fetchBatchHistData = async () => {
    try {
      /*let fmtSD = null;
      let fmtED = null;
       if(startDate != null) fmtSD = formatDateToStr(startDate)
      if(endDate != null) fmtED = formatDateToStr(endD ate)*/
      const res = await axios.post('/hist/batch', {
        /* startDate: fmtSD, endDate: fmtED */
      })
      const res_code = res.data.common.resultCode
      if (res_code == 'BH0200') {
        setBatchData(res.data.data.batchHsitList)
      } else {
        setBatchData([])
      }
    } catch (err) {
      console.error(err)
    }
  }

  const fetchStartBatch = async () => {
    const res = await axios.post(batchList[selectBacthIndex].batchStartApi, {}, { timeout: 20000 });
    const common = res.data.common
    if (common.resultCode === 'BATCH0206') {
      setStatus('running')
      showAlert({ type: 'success', title: '배치 실행을 성공했어요' })
    } else {
      if (common.resultCode === 'BATCH0207') {
        setStatus('running')
        showAlert({ title: '이미 실행 중이에요.' })
      } else if (common.resultCode === 'BATCH0208') {
        setStatus('warning')
        showAlert({ title: '서버 작업으로 인해 현재 사용 불가능한 상태예요.' })
      } else {
        setStatus('warning')
        showAlert({ title: common.resultCode, message: common.resultMsg })
      }
    }
  }

  const fetchStatus = async () => {
    const res = await axios.get(batchList[selectBacthIndex].batchStatusApi, { _disableLoading: true })
    const common = res.data.common
    const data = res.data.data
    if (common.resultCode === 'STATUS0200') {
      const serverStatus =
        data.status === 0 ? 'warning' : data.status == 1 ? 'ready' : 'running'
      setStatus((prev) => {
        if (prev !== 'ready' && serverStatus === 'ready') {
          fetchBatchHistData()
        }

        return serverStatus
      })
    } else {
      showAlert({ title: '현재 배치 상태를 조회 할 수 없어요.' })
      if ((window as any).batchStatusInterval) {
        clearInterval((window as any).batchStatusInterval)
      }
    }
  }

  const moveFailList = (baseDt: string, batchSeq: number, batchNm: string) => {
    navigate(`/batchExec/batchFailList`, {
      state: { baseDt: baseDt, batchSeq: batchSeq, batchNm: batchNm },
    })
  }

  const clearBatchInterval = () => {
    if ((window as any).batchStatusInterval) {
      clearInterval((window as any).batchStatusInterval)
      delete (window as any).batchStatusInterval
    }
  }

  useEffect(() => {
    clearBatchInterval()
    fetchBatchHistData()
    fetchStatus()
      ; (window as any).batchStatusInterval = setInterval(fetchStatus, 30000)
    return () => {
      clearBatchInterval()
    }
  }, [])

  const columns: TableColumn<BatchData>[] = [
    {
      name: 'No.',
      selector: (row, index) => batchData.length - (index as number),
      cell: (row, index) => (
        <div style={{ width: '100%', textAlign: 'right' }}>
          {batchData.length - (index as number)}
        </div>
      ),
    },
    {
      name: '모듈명',
      selector: (row) => row.batchNm,
    },
    {
      name: '시작일시',
      selector: (row) => row.startDate,
      format: (row) => commonUtils.formatDate(row.startDate, true),
      center: true,
    },
    {
      name: '종료일시',
      selector: (row) => row.endDate,
      format: (row) => commonUtils.formatDate(row.endDate, true),
      center: true,
    },
    {
      name: '상태',
      selector: (row) => getComCodeValue('STATUS', row.status)?.codeNm || '',
      center: true,
    },
    {
      name: '총 건수',
      selector: (row) => row.totalCnt,
      cell: (row, index) => (
        <div style={{ width: '100%', textAlign: 'right' }}>{row.totalCnt}</div>
      ),
    },
    {
      name: '성공 건수',
      selector: (row) => row.successCnt,
      cell: (row, index) => (
        <div style={{ width: '100%', textAlign: 'right' }}>
          {row.successCnt}
        </div>
      ),
    },
    {
      name: '실패 건수',
      selector: (row) => row.failCnt,
      cell: (row, index) => (
        <div style={{ width: '100%', textAlign: 'right' }}>{row.failCnt}</div>
      ),
    },
    {
      name: '',
      cell: (row) => (
        <>
          {row.failCnt > 0 && (
            <Button
              color="neverbe"
              variant="outlined"
              onClick={() => {
                moveFailList(
                  row.startDate.substring(0, 8),
                  row.batchSeq,
                  row.batchNm,
                )
              }}
            >
              상세
            </Button>
          )}
        </>
      ),
      center: true,
    },
  ]

  return (
    <Container>
      <Header>
        <p style={{ marginLeft: '20px', fontSize: '20px' }}>배치관리</p>
        <div style={{ marginLeft: 'auto' }}>
          <div style={{ display: 'flex', gap: '5px' }}>
            <FormGroup>
              <StatusLabel>프로그램</StatusLabel>
              <Select
                id="batch"
                name="batch"
                onChange={(e: any) => {
                  setSelectBacthIndex(e.target.value);
                  // console.log('batch change.. ', batchList[e.target.value])
                  // TODO 변경될때마다 상태조회를 할까
                  setStatus('ready');
                }}
                value={selectBacthIndex}
                width={'250px'}
              >
                {
                  batchList.map((batch, index) => (
                    <option key={'batch' + batch.batchNm} value={index}>
                      {batch.batchNm}
                    </option>
                  ))
                }
              </Select>
            </FormGroup>

            <FormGroup>
              <StatusLabel>대기 중</StatusLabel>
              <StatusLight active={status === 'ready'} color="#66ff99" />
            </FormGroup>
            <FormGroup>
              <StatusLabel>작업 중</StatusLabel>
              <StatusLight active={status === 'warning'} color="#ffcc66" />
            </FormGroup>
            <FormGroup>
              <StatusLabel>실행 중</StatusLabel>
              <StatusLight active={status === 'running'} color="#ff6666" />
            </FormGroup>
            <FormGroup>
              <Label htmlFor={''}>
                <></>
              </Label>
              <FlexWrapper gap="10px">
                <Button color="neverbe" onClick={fetchStartBatch}>
                  배치 실행
                </Button>
              </FlexWrapper>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={''}>
                <></>
              </Label>
              <FlexWrapper gap="10px">
                <Button color="neverbe" onClick={fetchStatus} variant='outlined'>
                  상태조회
                </Button>
              </FlexWrapper>
            </FormGroup>
          </div>
        </div>
      </Header>

      <Content>
        <TableContainer>
          <DataTable
            columns={columns}
            data={batchData}
            customStyles={tableStyles}
            noDataComponent={<div></div>}
            pagination={true}
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 20, 30, 50, 100, 500]}
          />
        </TableContainer>
      </Content>
    </Container>
  )
}

export default BatchExecPage
